import React from 'react';
import '../styles/sizeColor.css'

function sizeColor() {
    return(
        <div className='flex flex-row'>
            <div>
                <div>
                    <h1>Select size:</h1>
                </div>
                <div className='flex flex-row size text-size'>
                    <h2>XS</h2>
                    <h2>S</h2>
                    <h2>M</h2>
                    <h2>L</h2>
                    <h2>XL</h2>
                </div>
            </div>

            <div className='span'>
                <div>Select color:</div>
                <div className='flex flex-row'>
                    <span className='span1'><section></section></span>
                    <span className='span2'><section></section></span>
                    <span className='span3'><section></section></span>
                </div>
            </div>
        </div>
    )
}

export default sizeColor;